import axios from "axios";
import { ProdutoItemType } from "models/product_item_type";
import { ProductType } from "models/product_type";
import { UsuarioModel } from "models/user_model";
import { useEffect, useRef, useState } from "react";
import usePaymentForm from "views/admin/finance/paymentForm/hooks/usePaymentForm";

const useProductOrder = () => {


const [produtos, setProduto] = useState<ProductType[]>([]);
const [itens, setItens] = useState<ProdutoItemType[]>([]);
const [usuario, setUsuario] = useState<UsuarioModel>();
const [loading, setLoading] = useState(false);
const [show, setShow] = useState(false);
const [error, setError] = useState(false);
const [showDelete, setShowDelete] = useState(false);
const [accountSelected, setAccountSelected] = useState<ProductType>(null);
const [nome, setNome] = useState('');
const [errorTitle, setErrorTitle] = useState("");
const [errorMsg, setErrorMsg] = useState("");
const cancelRef = useRef();
const add = () => {
  showModal(true);
};

const changeNome = (value: string) => {
  setNome(value);
}


const changeItem = (item: ProdutoItemType, index: number) => {
  const newItems: ProdutoItemType[] = itens.map((existingItem, idx) => {
    if (index === idx) {
      return item;
    }
    if(item.principal){
      existingItem.principal = false;
    }
    return existingItem;
  });

  setItens(newItems);
};

const deleteRow = (item: ProdutoItemType) => {
  const list = itens;
  const data = list.filter((data) => data !== item);
  setItens(data);
}

const addRow = (item: ProdutoItemType) => {
  const newItems: ProdutoItemType[] = itens;
  const existe =  itens.find((valor) => valor.unidadeMedidaId === item.unidadeMedidaId);
  if(!existe) {
    if(item.principal){
      newItems.map((valor) => valor.principal = false); 
    }
    newItems.push(item);
    setItens(newItems);
  }

}

const edit = (item: ProductType) => {
  showModal(true);
  setAccountSelected(item);
  setItens(item?.ProdutoUnidade)
  setNome(item?.nome);
};

const showModal = (show: boolean) => {
  setShow(show);
  setError(false);
  if (!show) {
    setNome(null);
    setItens([]);
    setAccountSelected(null);
  }
};

const save = async () => {
  if (nome !== null) {
    setError(false);
    if (!accountSelected) {
      await addRegister();
    } else {
      await updateRegister();
    }

   setTimeout(async () => {
    await loadData();
   }, 500)
  } else {
    setError(true);
  }
};

const loadData = async () => {
  const userData = JSON.parse(localStorage.getItem("user"));
  setUsuario(userData);
  const response = await axios.get(
    process.env.REACT_APP_API_URL + "/produto/list/" + userData?.idEmpresa
  );
  if (response.data) {
    setLoading((prev) => (prev = false));
    setProduto(response.data);
  }
};

const addRegister = async () => {
  if(itens.length > 0) {
  const obj = {
    nome: nome,
    idEmpresa: usuario.idEmpresa,
    ativo: true,
  };
  const response = await axios.post(process.env.REACT_APP_API_URL + "/produto/", obj);
  if (response.data) {
    const retorno = response.data;


      itens.forEach(async (data) => {
        const valor = {
          diasPgto: data.diasPgto,
          idProduto: retorno,
          descricao: data.descricao,
          unidadeMedidaId: data.unidadeMedidaId,
          valorMax: data.valorMax,
          valorMin: data.valorMin,
          principal: itens.length === 1 ? true : data.principal,
          condicaoPagamentoId : data.condicaoPagamentoId,
        }
        await axios.post(process.env.REACT_APP_API_URL + "/produto/itens", valor)
      });
      setLoading((prev) => (prev = false));
      showModal(false);
      setNome(null);
      setItens([]);
      setAccountSelected(null);
    }
  } else {
    showError('Erro!', 'Você deve selecionar ao menos uma unidade de medida')
  }
};

const showError = (title: string, msg: string) => {
  setError(true);
  setErrorTitle(title);
  setErrorMsg(msg);
};


const updateRegister = async () => {
  if(itens.length > 0) {
  const obj = {
    id: accountSelected.id,
    nome: nome,
    idEmpresa: accountSelected.idEmpresa,
    ativo: true,
  };

  const response = await axios.patch(
    process.env.REACT_APP_API_URL + "/produto/" + accountSelected.id,
    obj
  );
  if (response.data === true) {

        await deletarItem();
        itens.forEach(async (data) => {
          const valor= {
            diasPgto: data.diasPgto,
            idProduto: accountSelected.id,
            descricao: data.descricao,
            unidadeMedidaId: data.unidadeMedidaId,
            valorMax: data.valorMax,
            valorMin: data.valorMin,
            principal: data.principal,
            condicaoPagamentoId : data.condicaoPagamentoId,
          }
          await axios.post(process.env.REACT_APP_API_URL + "/produto/itens", valor)
        });
      setLoading((prev) => (prev = false));
      showModal(false);
      setNome("");
      setItens([]);
      setAccountSelected(null);
    }
  } else {
    showError('Erro!', 'Você deve selecionar ao menos uma unidade de medida')
  }
  
}

const showDeleteModal = (item: ProductType) => {
  setShowDelete(true);
  setAccountSelected(item);
};

const closeDelete = () => {
  setShowDelete(false);
};

const deletar = async () => {
  const response = await axios.delete(
    process.env.REACT_APP_API_URL + "/produto/" + accountSelected?.id
  );
  if (response.data === true) {
    setLoading((prev) => (prev = false));
    showModal(false);
    setNome(null);
    setAccountSelected(null);
    setShowDelete(false);
    await loadData();
  }
};

const deletarItem = async () => {
  const response = await axios.delete(
    process.env.REACT_APP_API_URL + "/produto/itens/" + accountSelected?.id
  );
  if (response.data === true) {
    setLoading((prev) => (prev = false));
    showModal(false);
    setNome(null);
    setAccountSelected(null);
    setShowDelete(false);
    await loadData();
  }
};

const closeError = () => {
  setError(false);
};

const { condicaoPagamentos } = usePaymentForm();


useEffect(() => {
  loadData();
}, []);

return {
  produtos,
  add,
  edit,
  loading,
  show,
  showModal,
  nome,
  changeNome,
  accountSelected,
  error,
  save,
  deletar,
  showDeleteModal,
  showDelete,
  cancelRef,
  closeDelete,
  changeItem,
  deleteRow,
  addRow,
  itens,
  errorTitle,
  errorMsg,
  closeError,
  condicaoPagamentos,
  loadData
};
}


export default useProductOrder;